@if (isLoading()) {
  <elcia-loader/>
} @else {
  <p-table [scrollable]="true" [size]="'small'" [value]="mailTemplates()" scrollHeight="flex" stripedRows>
    <ng-template #header>
      <tr>
        <th pResizableColumn>{{ 'mail-template.name' | translate }}</th>
        <th pResizableColumn>{{ 'mail-template.object' | translate }}</th>
        <th pResizableColumn>{{ 'mail-template.language' | translate }}</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template #body let-row>
      <tr (click)="edit(row)" class="cursor-pointer hover:bg-gray-50">
        <td>{{ row.name }}</td>
        <td>{{ row.object }}</td>
        <td>{{ row.localIsoCode }}</td>
        <td class="flex justify-end gap-2">
          <elcia-button (onClick)="delete($event, row)" [icon]="'delete'" [severity]="'danger'" [variant]="'text'"/>
        </td>
      </tr>
    </ng-template>
  </p-table>
}
